import { router } from '@inertiajs/react'
import { NotaryPortalLayout } from '@/components/layout/NotaryPortalLayout'
import { DataTable } from '@/components/backoffice/DataTable'
import { Badge } from '@/components/ui/badge'
import { PortalNotarization } from '@/types'

type Props = {
  notarizations: PortalNotarization[]
}

const stageVariant: Record<string, 'default' | 'secondary' | 'outline'> = {
  application: 'outline',
  payment: 'outline',
  booking: 'secondary',
  session: 'secondary',
  completed: 'default',
}

export default function NotarizationsIndex({ notarizations }: Props) {
  return (
    <NotaryPortalLayout title="Notarizations">
      <div className="space-y-6">
        <div className="mb-8">
          <h1 className="text-xl font-semibold tracking-tight">Notarizations</h1>
          <p className="text-sm text-muted-foreground">
            All notarizations assigned to you ({notarizations.length} total)
          </p>
        </div>

        <DataTable
          data={notarizations}
          keyFn={(n) => n.id}
          emptyMessage="No notarizations assigned yet."
          onRowClick={(n) => router.visit(`/notary_portal/notarizations/${n.id}`)}
          columns={[
            {
              key: 'business',
              header: 'Business',
              className: 'flex-1 min-w-0',
              render: (n) => (
                <div className="min-w-0">
                  <p className="text-sm font-medium truncate">{n.business_name}</p>
                  <p className="text-[12px] text-muted-foreground truncate">{n.type_name}</p>
                </div>
              ),
            },
            {
              key: 'mode',
              header: 'Mode',
              className: 'w-28',
              render: (n) => (
                <Badge variant="outline" className="text-[11px] capitalize font-normal">
                  {n.session_mode.replace(/_/g, ' ')}
                </Badge>
              ),
            },
            {
              key: 'stage',
              header: 'Stage',
              className: 'w-28',
              render: (n) => (
                <Badge variant={stageVariant[n.stage] || 'outline'} className="text-[11px] capitalize font-normal">
                  {n.stage.replace(/_/g, ' ')}
                </Badge>
              ),
            },
          ]}
        />
      </div>
    </NotaryPortalLayout>
  )
}
